import React, { useState } from 'react';
import { Accordion } from 'react-accessible-accordion';
import { FiChevronDown, FiChevronRight } from 'react-icons/fi';
import { Item, ItemHeader, ItemPanel, ItemButton } from './styles';

export const AccordionItem = ({
  children,
  title,
  uuid,
}: {
  children: React.ReactNode;
  title: string;
  uuid: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Item uuid={uuid}>
      <ItemHeader
        onClick={() => {
          setIsOpen(prevState => !prevState);
        }}
      >
        <ItemButton>
          {isOpen ? <FiChevronDown /> : <FiChevronRight />}
          {title}
        </ItemButton>
      </ItemHeader>
      <ItemPanel>{children}</ItemPanel>
    </Item>
  );
};

export const AccordionGroup = ({
  children,
  onChange,
}: {
  children: React.ReactNode;
  onChange: (uuids: string[]) => void;
}) => {
  return (
    <Accordion onChange={onChange} allowZeroExpanded>
      {children}
    </Accordion>
  );
};

export default AccordionGroup;
